import React, { useState, useEffect } from "react";
import "./Implementation.css";
import img1 from "../metaverseassets/imp1.png";
import img2 from "../metaverseassets/imp2.png";
import img3 from "../metaverseassets/imp3.png";

export default function Implementation() {
  const cards = [
    {
      img: img1,
      title: "NFT minting and trading",
      desc: "Securely create and trade digital assets with transparent ownership and automated blockchain transactions.",
    },
    {
      img: img2,
      title: "Virtual land and asset tokenization",
      desc: "Transform virtual property and digital assets into tradable tokens with real economic value.",
    },
    {
      img: img3,
      title: "Smart contracts for transactions",
      desc: "Enable automated, trustless transactions through self-executing smart contracts.",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 576);

  // ✅ Fix 1: Update isMobile on window resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 576);
      setCurrentIndex(0); // reset on resize to avoid out-of-bounds
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const visibleCards = isMobile ? 1 : 2;
  const gap = 20; // px — match this to your CSS gap if any
  const maxIndex = cards.length - visibleCards;

  const goToSlide = (index) => {
    if (index > maxIndex) {
      setCurrentIndex(0);
    } else if (index < 0) {
      setCurrentIndex(maxIndex);
    } else {
      setCurrentIndex(index);
    }
  };

  // ✅ Fix 2: Use pixel-based translation accounting for gap
  const cardWidthPercent = isMobile ? 100 : 50;
  const translateValue = `calc(-${currentIndex * cardWidthPercent}% - ${currentIndex * gap}px)`;

  return (
    <div id="metaverse-implementation" className="metaversemainclass">
      <h2 className="heading">Blockchain & NFT Integration for Metaverse</h2>
      <p className="subheading">
        Blockchain-powered metaverse development enables secure digital
        ownership, transparent transactions, and decentralized economies. NFT
        integration allows users to own, trade, and monetize virtual assets
        within the metaverse.
      </p>

      <div className="cards">
        {cards.map((card, i) => (
          <div className="card" key={i}>
            <img src={card.img} alt="" />
            <h3>{card.title}</h3>
            <p>{card.desc}</p>
          </div>
        ))}
      </div>

      <div className="carousel-container">
        <div className="carousel-wrapper">
          {/* ✅ Fix 3: Add gap between cards via inline style on track */}
          <div
            className="carousel-track"
            style={{
              display: "flex",
              gap: `${gap}px`,
              transform: `translateX(${translateValue})`,
              transition: "transform 0.3s ease-in-out",
            }}
          >
            {cards.map((card, index) => (
              <div className="carousel-card" key={index}>
                <img src={card.img} alt="" />
                <h3>{card.title}</h3>
                <p>{card.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="carousel-nav dots">
          {Array.from({ length: maxIndex + 1 }).map((_, index) => (
            <span
              key={index}
              className={`dot ${currentIndex === index ? "active" : ""}`}
              onClick={() => goToSlide(index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}